export const googlec = function () {
  /* by creating chart here, and reusing it, memory leaks are reduced */
  let chart;
   
  function drawCharts() {
    Array.from( document.getElementsByClassName('gchart'))
         .forEach(e => { drawChart(e, chart) })
  }

  function drawChart( target, chart ) {
    $.getJSON( target.attributes["data-url"].value, function( serverData ) {
      let data = new google.visualization.DataTable();
      chart = new google.visualization.ChartWrapper();

      if ( serverData.cols.length > 0 ) {
        data.type = serverData.type;
        data.options = serverData.options;
        serverData.cols.forEach( col => { console.log("Adding col", ...col); data.addColumn(...col) });

        if (serverData.type == "Timeline")  
          convertTimelineDates(data, serverData.rows );
        else 
          if (serverData.type == "Calendar")  
            convertCalendarDates(data, serverData.rows );
          else 
            data.addRows( Object.entries(serverData.rows) );
      }
      else {
        data.addRows(serverData.rows );
        data.type = serverData.type;
      }

      chart.setChartType( serverData.type );
      chart.setDataTable( data );
      console.log("date.options ", data.options);
      chart.draw( target, data.options );
      data = null;
    });
  };
 
  let convertDate=function(utcDate) { return new Date(utcDate); }
    
  let convertTimelineDates=function(table, rows) {
    rows.forEach( r => {
      let fields = r.slice(0,-2);
      table.addRow( fields.
                    concat( convertDate( r[r.length - 2] ) ).
                    concat( convertDate( r[r.length - 1] ) )
                  );
    });
  };

  let convertCalendarDates=function(table, rows) {
    $.each(rows, function() {
    let row = this;
      row[0] = convertDate( row[0] );
      table.addRow( row );
    });
  };

  google.charts.load("current", {packages: ['corechart']});
  google.setOnLoadCallback(drawCharts);

};
